export default {
	
	selected: state => state.selected

}



// WEBPACK FOOTER //
// ./src/store/getters.js